import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
declare var $: any; // TODO hide modal in othe way

// Services
import { UserService, ResourceService, AuthService } from "@services/index.service";

// Interfaces
import { ResponseDataBase } from "@interfaces/index.interface";

//Constants
import { AppConstants } from "@app/appConstants";
import { environment } from "@environments/environment";

/** Esta página muestra la información del usuario y le permite modificar tanto la password como el mail. El resto de la información
 * solo puede ser modificada directamente desde SAP
 */
@Component({
  selector: "app-accountinfo",
  templateUrl: "./accountinfo.page.html",
})
export class AccountinfoComponent implements OnInit {

  environmentName = environment.envName;
  user;
  /** Como de la lengua sólo tenemos el id en esta variable guardamos el nombre */
  languageName;
  countryName;
  stateName;
  doctypeName;
  genderName;
  formaMail: FormGroup;
  formaPass: FormGroup;
  alert;
  optionalFields = environment.OPTIONAL_FIELDS_FOR_REGISTER;

  constructor(public _userService: UserService,
    public _resourceService: ResourceService,
    public _authService: AuthService) {

    /** Cogemos los datos del usuario para rellenar la página y buscamos el nombre del idioma a partir del Id. Configuramos
     * los formulario y sus validadores
     */
    this.user = this._userService.user;
    if (this._resourceService.languages.length) {
      this.languageName = this._resourceService.languages.filter(item => item.id === this.user.language).map(item => item.name)
    }
    if (this._resourceService.countries.length) {
      this.countryName = this._resourceService.countries.filter(item => item.id === this.user.country).map(item => item.name)
      if (!this.countryName.length && this.user.country) {
        this.countryName = this.user.country;
      }
    }
    if (this.optionalFields.STATE && this._resourceService.states.length) {
      this.stateName = this._resourceService.states.filter(item => item.id === this.user.state).map(item => item.name)
      if (!this.stateName.length && this.user.state) {
        this.stateName = this.user.state;
      }
    }
    if (this._resourceService.doctypes.length) {
      this.doctypeName = this._resourceService.doctypes.filter(item => item.id === this.user.docType).map(item => item.name)
    }
    if (this._resourceService.sexs.length) {
      this.genderName = this._resourceService.sexs.filter(item => item.id === this.user.gender).map(item => item.name)
    }

    this.formaMail = new FormGroup({
      "email": new FormControl("", [
        Validators.pattern("[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"),
        Validators.required
      ]),
      "confirmemail": new FormControl("", [
        Validators.required
      ]),
    });

    this.formaPass = new FormGroup({
      "password": new FormControl("", [
        Validators.required
      ]),
      "confirmpassword": new FormControl("", [
        Validators.required
      ]),
    });

    this.formaPass.controls["confirmpassword"].setValidators([
      this.notEqualPassword.bind(this.formaPass)
    ]);

    this.formaMail.controls["confirmemail"].setValidators([
      this.notEqualMail.bind(this.formaMail)
    ]);

  }

  /** Elimina la cuenta del usuario en el back */
  deleteAccount() {
    this._userService.deleteUser('').subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this._authService.logout();
        this._userService.loading = false;
      } else {
        this._resourceService.alert = response.METADATA.ERROR_MESSAGE;
      }
    });
  }

  /** Comprueba que los mails a modificar sean iguales */
  notEqualMail(control: FormControl): { [s: string]: boolean } {
    const forma: any = this;
    if (control.value !== forma.controls["email"].value) {
      return {
        notEqualsMail: true
      };
    }
    return null;
  }

  /** Comprueba que las passwords a modificar sean iguales */
  notEqualPassword(control: FormControl): { [s: string]: boolean } {
    const forma: any = this;
    if (control.value !== forma.controls["password"].value) {
      return {
        notEqualsPass: true
      };
    }
    return null;
  }

  /** Manda al back la petición de cambio del mail */
  changeMail() {
    let params = {
      email: this.formaMail.controls.email.value
    };
    this._userService.changeUserMail(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        $('#changeMailInfoModal').modal('show');
        this.alert = 'EMAIL_SUCCESSFULLY_CHANGE';
        window.scrollTo(0, 0);
      } else {
        this.alert = 'EMAIL_COULD_NOT_BE_CHANGED';
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });
  }

  /** Manda al back la petición de cambio del password */
  changePass() {
    let params = {
      password: this.formaPass.controls.password.value
    };
    this._userService.changeUserPass(params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS == AppConstants.STATUS.OK) {
        this.alert = 'SUCCESSFULLY_CHANGE_PASSWORD';
        window.scrollTo(0, 0);
      } else {
        this.alert = 'FAIL_CHANGE_PASSWORD';
        window.scrollTo(0, 0);
      }
      this._userService.loading = false;
    });
  }

  hidechangeMailInfoModal() {
    $('#changeMailInfoModal').modal('hide');
  }

  ngOnInit() {
    delete this.alert;
  }

}
